import React, {useCallback } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// GLOBAL METHODS
import { apiFetch, makePath, modalFunctions } from 'functions';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// MAIN COMPONENT
const EpostButton = () => {

  // REACT ROUTER
  const { recordID } = useParams();

  // CALLBACKS
  const sendEPostRequest = useCallback(
    () => apiFetch({
      method: 'PUT',
      endpoint: makePath(ENDPOINTS.inventory.ePost, recordID),
      params: {
        resend: true
      },
      loadingMessage: 'Sending Email',
      successMessage: 'Email sent successfully.',
      errorMessage: 'Error sending the email.'
    }),
    [recordID]
  )
  const handleClick = useCallback(
    () => modalFunctions.add({
      type: 'confirmation',
      title: 'E-Post Inventory Package to Accounting',
      body: 'Are you sure you want to resend the inventory package to accounting to be E-Posted?',
      continueButton: {
        label: 'E-Post',
        icon: {
          use: 'email'
        },
        onClick: sendEPostRequest
      }
    }),
    [sendEPostRequest]
  )

  // RENDER
  return (
    <Button
      label="E-Post"
      icon="email"
      onClick={handleClick}
      size="sm"
      outline
      fullWidth={false}
    />
  );
};

// EXPORT
export default EpostButton;
